<template>
  <v-container id="dashboard" fluid tag="section">
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12" md="6" xl="3">
          <StatusCardDept
            title="Requisição"
            headIcon="mdi-note-outline"
            :departments="requisicao.departments"
            :rows="requisicao.rows"
            :loading="loadingCards"
            :updatedAt="updatedAt"
            :url="requisicao" 
            to="/requisicao"
            v-if="isAllowed(8)"
          />
        </v-col>

        <v-col cols="12" md="6" xl="3">
          <StatusCardDept
            title="Requisição de Serviço"
            headIcon="mdi-note-outline"
            :departments="requisicaoServico.departments"
            :rows="requisicaoServico.rows"
            :loading="loadingCards"
            :updatedAt="updatedAt"
            to="/requisicaoServico"
            v-if="isAllowed(8)"
          />
        </v-col>

        <v-col cols="12" md="6" xl="3">
          <StatusCardDept
            title="Solicitação"
            headIcon="mdi-note-outline"
            :departments="solicitacao.departments"
            :rows="solicitacao.rows"
            :loading="loadingCards"
            :updatedAt="updatedAt"
            to="/solicitacao"
            v-if="isAllowed(9)"
          />
        </v-col>

        <v-col cols="12" md="6" xl="3">
          <StatusCardDept
            title="Mapa de Compra"
            headIcon="mdi-map"
            :departments="mapaCompra.departments"
            :rows="mapaCompra.rows"
            :loading="loadingCards"
            :updatedAt="updatedAt"
            to="/mapaCotacao"
            v-if="isAllowed(10)"
          />
        </v-col>
        <v-col cols="12" md="6" xl="3">
          <StatusCardDept
            title="Ordem de Serviço"
            headIcon="mdi-map"
            :departments="ordemServico.departments"
            :rows="ordemServico.rows"
            :loading="loadingCards"
            :updatedAt="updatedAt"
            to="/ordemServico"
            v-if="isAllowed(17)"
          />
        </v-col>
        <v-col cols="12" md="6" xl="3">
          <StatusCardDept
            title="Chamado de Manutenção"
            headIcon="mdi-map"
            :rows="chamadoManutencao.rows"
            :departments="chamadoManutencao.departments"
            :loading="loadingCards"
            :updatedAt="updatedAt"
            to="/chamadoManutencao"
            v-if="isAllowed(18)"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import StatusCardDept from "./base/StatusCardDept.vue";
import {obterMetricasAsync as metricasRequisicao} from "../services/requisicaoService";
import {obterMetricasAsync as metricasRequisicaoServico}  from "../services/requisicaoServicoService";
import {obterMetricasAsync as metricasColicitacao}  from "../services/solicitacaoService";
import {obterMetricasAsync as metricasMapaCotacao}  from "../services/mapaCotacaoService";
import {obterMetricasAsync as metricasOrdemServico}  from "../services/ordemServicoService";
import {obterMetricasAsync as metricasChamadoManutencao}  from "../services/chamadoManutencaoService";
import {
  getUserRoles,
} from "../services/loginService";

const STATUS_CONFIG = {
  requisicao: [
    { code: "TD", label: "Todas", color: "blue" },
    { code: "AA", label: "Ag. Aprovação", color: "red" },
    { code: "PA", label: "Analisado Pelo Gestor", color: "green" },
    { code: "B", label: "Baixada", color: "grey darken-1" },
    { code: "D", label: "Declinada", color: "grey darken-1" },
    { code: "I", label: "Inativa", color: "grey darken-1" },
  ],

  requisicaoServico: [
    { code: "TD", label: "Todas", color: "blue" },
    { code: "AA", label: "Ag. Aprovação", color: "red" },
    { code: "PA", label: "Analisado Pelo Gestor", color: "green" },
    { code: "PG", label: "Pedido Gerado", color: "green" },
    { code: "B", label: "Baixada", color: "grey darken-1" },
    { code: "D", label: "Declinada", color: "grey darken-1" },
    { code: "I", label: "Inativa", color: "grey darken-1" },
  ],

  solicitacao: [
    { code: "TD", label: "Todas", color: "blue" },
    { code: "AA", label: "Ag. Autorização", color: "red" },
    { code: "AG", label: "Analisado Pelo Gestor", color: "yellow darken-2" },
    { code: "PC", label: "Processo de Cotação", color: "yellow darken-2" },
    { code: "PP", label: "Pedido Parcial", color: "yellow darken-2" },
    { code: "PG", label: "Pedido Gerado", color: "green" },
    { code: "EP", label: "Entrada Parcial", color: "yellow darken-2" },
    { code: "BX", label: "Solicitação Baixada", color: "grey darken-1" },
    { code: "D", label: "Declinada", color: "grey darken-1" },
    { code: "I", label: "Inativa", color: "grey darken-1" },
  ],

  mapaCompra: [
    { code: "TD", label: "Todas", color: "blue" },
    { code: "PC", label: "Processo de Cotação", color: "yellow darken-2" },
    { code: "AA", label: "Ag. Aprovação", color: "red" },
    { code: "AG", label: "Aprovado", color: "green" },
    { code: "D", label: "Declinada", color: "yellow darken-2" },
    { code: "PP", label: "Pedido Parcial", color: "yellow darken-2" },
    { code: "PG", label: "Pedido Gerado", color: "green" },
    { code: "I", label: "Inativa", color: "grey darken-1" },
  ],
  ordemServico: [
    { code: "TD", label: "Todas", color: "blue" },
    { code: "EA", label: "Em Aberto", color: "red" },
    { code: "AA", label: "Aguardando Autorização", color: "green" },
    { code: "B", label: "Baixada", color: "grey darken-1" },
    { code: "I", label: "Inativa", color: "grey darken-1" },
  ],
  chamadoManutencao: [
    { code: "TD", label: "Todas", color: "blue" },
    { code: "EA", label: "Em Aberto", color: "red" },
    { code: "OG", label: "Ordem Serviço Gerada", color: "green" },
    { code: "B", label: "Baixada", color: "grey darken-1" },
    { code: "I", label: "Inativa", color: "grey darken-1" },
  ],
};

export default {
  components: { StatusCardDept },

  data() {
    return {
      loadingCards: false,
      updatedAt: null,

      requisicao: { departments: [], rows: [] },
      requisicaoServico: { departments: [], rows: [] },
      solicitacao: { departments: [], rows: [] },
      mapaCompra: { departments: [], rows: [] },
      ordemServico: { departments: [], rows: [] },
      chamadoManutencao: { departments: [], rows: [] },
    };
  },

  mounted() {
    this.loadCards();
  },

  created() {
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  methods: {
    async loadCards() {
      this.loadingCards = true;
      try {
        this.loadRequisicaoCard();
        this.loadRequisicaoServicoCard();
        this.loadSolicitacaoCard();
        this.loadMapaCard();
        this.loadOSCard();
        this.loadChamadoCard();

        this.updatedAt = new Date();
      } finally {
        this.loadingCards = false;
      }
    },
    async loadRequisicaoCard() {
      const raw = await metricasRequisicao();
      this.requisicao = this.buildCardTable(raw, STATUS_CONFIG.requisicao);
    },
    async loadRequisicaoServicoCard() {
      const raw = await metricasRequisicaoServico();
      const statusVisivel = (raw || []).map((item) => ({
        ...item,
        status:
          item.status === "AL"
            ? "AA"
            : item.status === "LA"
            ? "PA"
            : item.status === "LD"
            ? "D"
            : item.status,
      }));
      this.requisicaoServico = this.buildCardTable(
        statusVisivel,
        STATUS_CONFIG.requisicaoServico
      );
    },
    async loadSolicitacaoCard() {
      const raw = await metricasColicitacao();
      this.solicitacao = this.buildCardTable(raw, STATUS_CONFIG.solicitacao);
    },
    async loadMapaCard() {
      const raw = await metricasMapaCotacao();
      this.mapaCompra = this.buildCardTable(raw, STATUS_CONFIG.mapaCompra);
    },
    async loadOSCard() {
      const raw = await metricasOrdemServico();
      this.ordemServico = this.buildCardTable(raw, STATUS_CONFIG.ordemServico);
    },
    async loadChamadoCard() {
      const raw = await metricasChamadoManutencao();
      this.chamadoManutencao = this.buildCardTable(raw, STATUS_CONFIG.chamadoManutencao);
    },
    buildCardTable(raw, config) {
      // departamentos dinâmicos
      const departments = [
        ...new Set((raw || []).map((x) => x.departamento)),
      ].sort();

      // index: counts[status][departamento] = soma
      const counts = {};
      for (const item of raw || []) {
        const st = item.status;
        const dep = item.departamento;
        const val = Number(item.somaStatus || 0);

        if (!counts[st]) counts[st] = {};
        counts[st][dep] = (counts[st][dep] || 0) + val; // soma se vier duplicado
      }

      // se TD (Todas) não vier da API, calcula somando os demais status por dept
      const hasTDinApi = !!counts["TD"];
      if (!hasTDinApi && config.some((c) => c.code === "TD")) {
        counts["TD"] = {};
        for (const dep of departments) {
          let sum = 0;
          for (const st of Object.keys(counts)) {
            sum += Number(counts[st][dep] || 0);
          }
          counts["TD"][dep] = sum;
        }
      }

      // monta linhas na ordem do config (status que não veio -> 0)
      const rows = config.map((s) => ({
        code: s.code,
        label: s.label,
        color: s.color,
        counts: departments.reduce((acc, dep) => {
          acc[dep] = Number((counts[s.code] && counts[s.code][dep]) || 0);
          return acc;
        }, {}),
      }));

      return { departments, rows };
    },
    isAllowed(id) {
      return (
        this.regras.filter((r) => {
          return r.idModulo == id;
        }).length > 0
      );
    },
  },
};
</script>
